import { AreaDesignation, IAreaTypeCategoryResponse } from "@miplatform/types";

export const CATEGORY_STATUS = {
  ADDED: "added",
  EXISTING: "existing",
  REMOVED: "removed",
} as const;

export type CategoryStatus =
  (typeof CATEGORY_STATUS)[keyof typeof CATEGORY_STATUS];

export interface IAreaTypeData {
  name: string;
  areaDesignation: AreaDesignation;
  specColumn: number;
  categories: IAreaTypeCategoryResponse[];
  id?: string;
  modifiedOn?: string;
}
